/*                                         */
/*                                                             */

import type { ActionReturn } from 'svelte/action';

let intersectionObserver: IntersectionObserver;

function ensureIntersectionObserver() {
  if (intersectionObserver) return;

  const options: IntersectionObserverInit = {
    threshold: 0.3,
  };

  const callback: IntersectionObserverCallback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
        entry.target.dispatchEvent(new CustomEvent('EnterViewport'));
      }
    });
  };

  intersectionObserver = new IntersectionObserver(callback, options);
}

interface Attributes {
  onEnterViewport: (e: CustomEvent<boolean>) => void
}

const viewport = (element: Element): ActionReturn<undefined, Attributes> => {
  ensureIntersectionObserver();

  intersectionObserver.observe(element);

  return {
    destroy() {
      intersectionObserver.unobserve(element);
    },
  };
};

export default viewport;
